import React from 'react';

import { Chip } from '@mui/material';

const KeywordItem = ({ keyword, setProdValues }) => {
    // eliminar keyword
    const onClick = () => {
        setProdValues(e => ({
            ...e,
            keywords: e.keywords.filter(i => (keyword !== i))
        })
        );
    };

    return (
        <Chip label={keyword} onDelete={onClick} variant='outlined' color='primary' sx={{borderRadius: '0px'}} />
    );
};

export default KeywordItem;